module.exports = __webpack_public_path__ + "img/register-drop-down.85aab414.svg";